import { connect } from 'react-redux';
import CaseMetricsDispatcherComponent
  from './../Components/CaseMetricsDispatcherComponent';

import {
  setArtifactsMetricsInfo,
  setCaseMetricsInfo
} from './../actions';
import { pageTypes } from '../helpers';

export const mapStateToProps = (state, ownProps) => {
  return { jumpDestination: ownProps.jumpDestination.type };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onJumpToClick: () => ownProps.jumpDestination === pageTypes.CASEMETRICS ?
      dispatch(setCaseMetricsInfo()) :
      dispatch(setArtifactsMetricsInfo())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseMetricsDispatcherComponent);


// WEBPACK FOOTER //
// src/Containers/CaseMetricsDispatcherContainer.jsx